export default __webpack_public_path__ + "static/media/input2.9cd35f7c.svg";